<template>
  <label>
    <slot></slot>
  </label>
</template>
<script>
export default {
  name: 'Label'
};
</script>
